/**
 * Accessible tabs for the product-tabs block.
 * Clicking a tab or using the arrow keys / Home / End shows its panel.
 */
class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('keydown', this.#onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('keydown', this.#onKeydown);
  }

  get #tabs() {
    return Array.from(this.querySelectorAll('[role="tab"]'));
  }

  #onClick = (event) => {
    const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
    if (tab instanceof HTMLElement) this.#select(tab);
  };

  #onKeydown = (event) => {
    const tabs = this.#tabs;
    const index = tabs.indexOf(/** @type {HTMLElement} */ (document.activeElement));
    if (index === -1) return;

    let next;
    if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
    else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
    else if (event.key === 'Home') next = tabs[0];
    else if (event.key === 'End') next = tabs[tabs.length - 1];
    if (!next) return;

    event.preventDefault();
    this.#select(next);
    next.focus();
  };

  /** @param {HTMLElement} selected */
  #select(selected) {
    for (const tab of this.#tabs) {
      const isSelected = tab === selected;
      tab.setAttribute('aria-selected', String(isSelected));
      tab.tabIndex = isSelected ? 0 : -1;
      const panel = this.querySelector(`[id="${tab.getAttribute('aria-controls')}"]`);
      panel?.toggleAttribute('data-inactive', !isSelected);
    }
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs);
}
